import type { ApolloError } from '@apollo/client';

export const CACHE_FIRST: any = {
  fetchPolicy: 'cache-first',
  onError: (error: ApolloError) => {
    // eslint-disable-next-line no-console
    console.log(error.message, error.cause, error.extraInfo);
  }
};

export const CACHE_ONLY: any = {
  fetchPolicy: 'cache-only',
  onError: (error: ApolloError) => {
    // eslint-disable-next-line no-console
    console.log(error.message, error.cause, error.extraInfo);
  }
};

export const APOLLO_BASE_OPTIONS: any = {
  fetchPolicy: 'cache-and-network',
  nextFetchPolicy: 'cache-first',
  notifyOnNetworkStatusChange: true,
  onError: (error: ApolloError) => {
    // eslint-disable-next-line no-console
    console.log(error.message, error.cause, error.extraInfo);
  }
};

export const NETWORK_FIRST: any = {
  fetchPolicy: 'network-only',
  nextFetchPolicy: 'cache-first',
  notifyOnNetworkStatusChange: true,
  onError: (error: ApolloError) => {
    // eslint-disable-next-line no-console
    console.log(error.message, error.cause, error.extraInfo);
  }
};
